import { InfoFaqAction } from "Components/InfoFaq/Redux/actions";

export interface IInfoFaq {
  isFetching: boolean;
  isFetchFailed: boolean;
  faqList: Julius.Website.FAQViewModel[];
};

const initialInfoFaq: IInfoFaq = {
  isFetching: false,
  isFetchFailed: false,
  faqList: [],
};

function infoFaq(
  state: IInfoFaq = initialInfoFaq, 
  action: InfoFaqAction,
  ): IInfoFaq {
    
  switch (action.type) {
    case 'SET_IS_FETCHING_FAQ':
      return {
        ...state,
        isFetching: true,
        isFetchFailed: false,
      };

    case 'SET_FETCH_FAQ_FAILED':
      return {
        ...state,
        isFetching: false,
        isFetchFailed: true,
      };

    case 'SET_FAQ':
      return {
        ...state,
        faqList: action.faqList,
        isFetching: false,
        isFetchFailed: false,
      };

    default:
      return state;
  }
}

export default infoFaq;


// WEBPACK FOOTER //
// ./src/components/InfoFaq/Redux/reducer.tsx